import { Repeat, CalendarDays } from "lucide-react";

export default function RecurrenceScopeDialog({ open, onChoose, onCancel, label }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-end md:items-center justify-center p-4" data-testid="recurrence-scope-dialog">
      <div className="absolute inset-0 bg-[#3B443D]/40" onClick={onCancel} />
      <div className="relative w-full max-w-sm bg-white rounded-2xl border border-[#E4E7E1] shadow-xl p-5">
        <div className="tl-label">Attività ricorrente</div>
        <div className="font-serif-display text-xl font-semibold text-[#3B443D] leading-tight mt-0.5">
          {label || "Applicare la modifica a..."}
        </div>
        <div className="mt-4 flex flex-col gap-2">
          <button
            type="button"
            onClick={() => onChoose("single")}
            className="tl-btn-primary flex items-center gap-2 w-full px-4 py-3 rounded-xl bg-[#A3B897] hover:bg-[#8FA087] text-white text-sm font-medium transition-all"
            data-testid="scope-single"
          >
            <CalendarDays size={16} strokeWidth={1.75} />
            Solo questo giorno
          </button>
          <button
            type="button"
            onClick={() => onChoose("all")}
            className="flex items-center gap-2 w-full px-4 py-3 rounded-xl bg-white border border-[#E4E7E1] text-sm text-[#3B443D] hover:bg-[#F3F5F0] transition-colors"
            data-testid="scope-all"
          >
            <Repeat size={16} strokeWidth={1.75} />
            Tutte le occorrenze
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="w-full px-4 py-2 rounded-full text-sm text-[#58635B] hover:bg-[#F3F5F0]"
            data-testid="scope-cancel"
          >
            Annulla
          </button>
        </div>
      </div>
    </div>
  );
}
